// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"e774529a","465":"4996203c","625":"ae04887c","722":"7447e79d","823":"74e89425"}[chunkId] + ".chunk.js";
};